import React from 'react';

const deals = (props) => {
    return (
        props.deals.map( deal => (
            <div onClick={() => props.clickHandler(deal._id)} className="item" key={deal._id} style={{cursor:'pointer'}}>
                <div className={deal.is_bumped ? "category-box-outer deals-highlight" : "category-box-outer"}>
                    <div className="category-box-header">
                        <img src={deal.image} alt={deal.name}/>
                        {deal.is_bumped && <div className="featured-deal">Featured</div>}
                    </div>
                    <div className="category-box-body">
                        <p className="category-box-body-title custom-height">{deal.category.name}</p>
                        <p className="category-box-body-subtitle custom-height">{deal.name}</p>
                    </div>
                </div>
            </div>
        ))
    );
}

export default deals;